import { Component, Input, SimpleChanges } from '@angular/core';
import { IRptEspCobDet, IRptEspCobPay } from '../../../shared/interfaces/rptEspCob';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-rpt-esp-cob-det',
  imports: [],
  templateUrl: './rpt-esp-cob-det.component.html',
  styleUrl: '../rpt-esp-cob.component.css',
  standalone: false
})
export class RptEspCobDetComponent {
  @Input() details: IRptEspCobDet[];
  @Input() payments: IRptEspCobPay[];
  @Input() engLang: boolean;

  dataSource: MatTableDataSource<IRptEspCobDet> = new MatTableDataSource<IRptEspCobDet>();
  displayedColumns: string[] = [
    'ps',
    'detFromDt',
    'detToDt',
    'pcode',
    'xpect',
    'privado',
    'DetQty',
    'DetDesc'
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['details'] && this.details) {
      this.dataSource.data = this.details.slice(); // Create a new array to avoid reference issues
    }
  }

  makeNum(value: number | string): number {
    return Number(value.toString().replace(/,/g, '')); // Convert string with commas to number
  }

}
